import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout';
import { Table, Button, Modal, TextInput, Card, Text, Switch, LoadingOverlay, Loader } from '@mantine/core';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployees, activateDeactivateEmployee, createNewEmployee } from '../../actions/employeeActions';
import { useNotifications } from '@mantine/notifications';
import { useForm } from '@mantine/hooks';

const Employees = ({ title }) => {

    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const notifications = useNotifications();

    const { loading, error, employees } = useSelector((state) => state.employees);
    const { error: changeEmployeeError, changeEmployee } = useSelector((state) => state.changeEmployee);
    const { loading: createNewEmployeeLoading, error: createNewEmployeeError, createEmployee } = useSelector((state) => state.createEmployee);

    const form = useForm({
        initialValues: {
            name: '',
            contact: '',
        },
        errorMessages: {
            name: 'Name is invalid',
            contact: 'Contact Number is invalid',
        },
        validationRules: {
            name: (value) => /[a-zA-Z]+/g.test(value),
            contact: (value) => value.length === 10
        },
    });

    const handlerChangeEmployee = (id) => {
        dispatch(activateDeactivateEmployee(id))
    }

    const handlerCreateEmployee = (values) => {
        setOpened(false)
        const { name, contact } = values;
        dispatch(createNewEmployee(name, contact))
    }

    const rows = employees && employees.map((employee) => (
        <tr key={employee.uuid}>
            <td>{employee.uuid}</td>
            <td>{employee.name}</td>
            <td>{employee.contact}</td>
            <td><Switch size='md' color='orange' checked={employee.activated} onChange={(e) => handlerChangeEmployee(employee.uuid)} /></td>
        </tr>
    ));

    useEffect(() => {
        if (error || changeEmployeeError || createNewEmployeeError) {
            notifications.showNotification({
                title: 'Error',
                message: error,
                color: 'red'
            })
        }
        // eslint-disable-next-line
    }, [error])

    useEffect(() => {
        if (changeEmployee) {
            notifications.showNotification({
                title: 'Success',
                message: 'Employee record changed',
                color: 'green'
            })
        }
        // eslint-disable-next-line
    }, [changeEmployee])

    useEffect(() => {
        if (createEmployee) {
            notifications.showNotification({
                title: 'Success',
                message: 'Employee record added',
                color: 'green'
            })
        }
        // eslint-disable-next-line
    }, [createEmployee])

    useEffect(() => {
        dispatch(getEmployees())
    }, [dispatch, changeEmployee, createEmployee])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Layout activeKey={2}>
                <Modal
                    closeOnClickOutside={false}
                    centered
                    opened={opened}
                    onClose={() => setOpened(false)}
                    title="Add New Employee"
                    radius='md'
                >
                    <form onSubmit={form.onSubmit((values) => handlerCreateEmployee(values))}>
                        <TextInput
                            placeholder="Employee name"
                            label="Name"
                            required
                            radius='md'
                            {...form.getInputProps('name')}
                            error={form.errors.name}
                        />
                        <TextInput
                            radius='md'
                            sx={{ margin: '20px 0' }}
                            placeholder="Employee phone"
                            label="Phone"
                            required
                            {...form.getInputProps('contact')}
                            error={form.errors.contact}
                        />
                        <Button loading={createNewEmployeeLoading} type='submit' radius='md' sx={{ margin: '20px 0' }} fullWidth loaderPosition="right" color="orange" onClick={() => setOpened(true)}>
                            Add New Employee
                        </Button>
                    </form>
                </Modal>

                <Card radius='lg' shadow="sm">
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Employees</Text>
                        <Button radius='md' color="orange" onClick={() => setOpened(true)}>Add Employee</Button>
                    </span>

                    {loading ? <LoadingOverlay visible={true} loader={<Loader color='orange' />} /> : <Table highlightOnHover>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Employee Name</th>
                                <th>Employee Phone</th>
                                <th>Activate/ Deactivate</th>
                            </tr>
                        </thead>

                        <tbody>
                            {rows}
                        </tbody>

                    </Table>}

                </Card>



            </Layout>
        </>
    )
}

export default Employees
